interface ModalAuthorizeFGTSProps {
  open: boolean;
  onAdvance: () => void;
}

const ModalAuthorizeFGTS = ({ open, onAdvance }: ModalAuthorizeFGTSProps) => {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="relative mx-2 flex w-full max-w-lg flex-col items-center rounded-2xl bg-white p-5 shadow-xl">
        <h2 className="mb-2 text-center text-lg font-semibold text-black01 sm:text-xl">
          Autorize o acesso ao seu FGTS
        </h2>
        <p className="mb-5 text-center text-sm font-medium text-black01 sm:text-base">
          Para continuar, é preciso autorizar o acesso
          <br />
          no app do seu banco. É rápido e seguro
        </p>
        <button
          className="w-full rounded-full bg-primary py-4 text-base font-bold text-white01 hover:bg-primary"
          onClick={onAdvance}
        >
          Avançar
        </button>
      </div>
    </div>
  );
};

export default ModalAuthorizeFGTS;
